export default __webpack_public_path__ + "51cf00f3190867a6b678266e9124f2ea.png";